/** Used as both the UI placeholder and the Moment.js format string */
export const REWARD_APP_PREVIEW_EXPIRY_DISPLAY_FORMAT = 'MM/DD/YYYY';
